import { PopoverProps } from '@radix-ui/react-popover';

import { HTMLDataTrackerProps } from '@/app/types';
import {
  PopupImageLinkStrapi,
  PopupImageLinkStrapiProps,
} from '@/components/atoms/PopupImageLink/PopupImageLinkStrapi';

import { SocialWidgetEntry } from './SocialWidgetStrapi';

type SocialWidgetItemListProps = SocialWidgetEntry & {
  handleSelectCallback: () => void;
  PopupProps?: Partial<PopoverProps>;
} & HTMLDataTrackerProps;

const SocialWidgetItem = (props: SocialWidgetItemListProps) => {
  const { handleSelectCallback, link, popup, PopupProps, icon } = props;

  let popupImage;
  if (popup == null) {
    popupImage = undefined;
  } else if (Array.isArray(popup)) {
    popupImage = popup[0];
  } else {
    popupImage = popup;
  }

  const transformedSingleEntryProps: PopupImageLinkStrapiProps = {
    inner: {
      link: {
        variant: 'text',
        ...link,
      },
      popupImage: {
        className: 'w-36 h-auto',
        'data-tracker-context': props['data-tracker-context'],
      },
      popup: {
        position: 'left',
        showArrow: true,
        onChangeCallback: handleSelectCallback,
        classNames: {
          arrow: 'fill-base-white',
          childrenWrapper: 'border-none shadow-xl rounded-lg',
        },
        contentProps: {
          className: 'p-0 border-none w-42',
          sideOffset: 24,
        },
        ...PopupProps,
      },
      image: {
        className: 'h-10 w-10 p-2',
        ...icon,
        'data-tracker-context': props['data-tracker-context'],
      },
    },
    block: {
      image: icon,
      link: link,
      popup: popupImage,
    },
  };

  return <PopupImageLinkStrapi {...transformedSingleEntryProps} />;
};

export default SocialWidgetItem;
